import { render, staticRenderFns } from "./DragItem.vue?vue&type=template&id=b7f95950&scoped=true&"
import script from "./DragItem.vue?vue&type=script&lang=js&"
export * from "./DragItem.vue?vue&type=script&lang=js&"
import style0 from "./DragItem.vue?vue&type=style&index=0&id=b7f95950&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f95950",
  null
  
)

export default component.exports